module.exports = __webpack_public_path__ + "img/thumb_11.fac596d5.jpg";